import React, { useContext, useState } from 'react'
import { components, useTranslation } from 'cng-web-lib'
import Namespace from '../../../../constants/locale/Namespace'
import AciAirKeys from '../../../../constants/locale/key/AciAir'
import { LookupsContext } from '../../../../contexts/LookupsContext'
import StatusBar from '../../../../components/aciacehighway/StatusBar'
import CngField from '../../../../components/cngcomponents/CngField'
import CngSection from '../../../../components/cngcomponents/CngSection'
import TinyChip from '../../../../components/aciacehighway/TinyChip'
import LocalTable from '../../../../components/aciacehighway/LocalTable'
import ItemViewContent from './ItemViewContent'
import { Box, Card, CircularProgress, Divider, Grid, Typography, useTheme } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'
import _ from 'lodash'
import ViewLogsHistory from '../../aciaircommon/ViewLogsHistory'

const { button: { CngButton }, CngDialog } = components

function ReportViewContent(props) {
  const { data, reportId, showNotification } = props

  const [itemDialog, setItemDialog] = useState({ open: false, item: null })
  const { getLookupValue } = useContext(LookupsContext)
  const { translate } = useTranslation(Namespace.ACI_AIR)
  const translatedTextsObject = makeTranslatedTextsObject()
  const theme = useTheme()

  function makeTranslatedTextsObject() {
    const schedule = translate(Namespace.ACI_AIR, AciAirKeys.SCHEDULE)
    const customsProc = translate(Namespace.ACI_AIR, AciAirKeys.CUSTOMS_PROC)
    const convRefNo = translate(Namespace.ACI_AIR, AciAirKeys.CONV_REF_NO)
    const flightNo = translate(Namespace.ACI_AIR, AciAirKeys.VOYAGE_NO)
    const originalCCN = translate(Namespace.ACI_AIR, AciAirKeys.ORIGINAL_C_C_N)
    const carrierCode = translate(Namespace.ACI_AIR, AciAirKeys.CARRIER_CODE)
    const portOfLoading = translate(
      Namespace.ACI_AIR,
      AciAirKeys.PORT_OF_LOADING
    )
    const receiptCountry = translate(
      Namespace.ACI_AIR,
      AciAirKeys.RECEIPT_COUNTRY
    )
    const receiptCity = translate(Namespace.ACI_AIR, AciAirKeys.RECEIPT_CITY)
    const deliveryCountry = translate(
      Namespace.ACI_AIR,
      AciAirKeys.DELIVERY_COUNTRY
    )
    const deliveryCity = translate(Namespace.ACI_AIR, AciAirKeys.DELIVERY_CITY)
    const customsOff = translate(Namespace.ACI_AIR, AciAirKeys.CUSTOMS_OFF)
    const warehouseDischarge = translate(
      Namespace.ACI_AIR,
      AciAirKeys.WAREHOUSE_DISCHARGE
    )
    const splitShipmentInd = translate(
      Namespace.ACI_AIR,
      AciAirKeys.SPLIT_SHIPMENT_IND
    )
    const rampTransferInd = translate(
      Namespace.ACI_AIR,
      AciAirKeys.RAMP_TRANSFER_IND
    )
    const suppReqInd = translate(Namespace.ACI_AIR, AciAirKeys.SUPP_REQ_IND)
    const specialIns = translate(Namespace.ACI_AIR, AciAirKeys.SPECIAL_INS)
    const scheduleDateAndTime = translate(
      Namespace.ACI_AIR,
      AciAirKeys.SCHEDULE_DATE_TIME
    )
    const uniqueConsignmentRefNo = translate(
      Namespace.ACI_AIR,
      AciAirKeys.UNIQUE_CONSIGNMENT_REF_NO
    )
    const receiptTerminalName = translate(
      Namespace.ACI_AIR,
      AciAirKeys.RECEIPT_TERMINAL_NAME
    )
    const cargoFacilityLoc = translate(
      Namespace.ACI_AIR,
      AciAirKeys.CARGO_FACILITY_LOC
    )
    const customsOfficeDischarge = translate(
      Namespace.ACI_AIR,
      AciAirKeys.CUSTOMS_OFF_DISCHARGE
    )
    const customsOfficeDischargeLoc = translate(
      Namespace.ACI_AIR,
      AciAirKeys.CUSTOMS_OFF_DISCHARGE_LOC
    )
    const aciAirRouteList = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirRouteList.TITLE
    )
    const routeCarrierCode = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirRouteList.CARRIER_CODE
    )
    const locationCode = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirRouteList.LOCATION_CODE
    )
    const aciAirPartyList = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirPartyList.TITLE
    )
    const partyType = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirPartyList.PARTY_TYPE
    )
    const partyName1 = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirPartyList.PARTY_NAME1
    )
    const partyName2 = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirPartyList.PARTY_NAME2
    )
    const address1 = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirPartyList.ADDRESS1
    )
    const address2 = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirPartyList.ADDRESS2
    )
    const city = translate(Namespace.ACI_AIR, AciAirKeys.AciAirPartyList.CITY)
    const stateCode = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirPartyList.STATE_CODE
    )
    const postalCode = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirPartyList.POSTAL_CODE
    )
    const countryCode = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirPartyList.COUNTRY_CODE
    )
    const contactPerson = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirPartyList.CONTACT_PERSON
    )
    const telNo = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirPartyList.TEL_NO
    )
    const aciAirManifestQtyList = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirManifestQtyList.TITLE
    )
    const quantity = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirManifestQtyList.QUANTITY
    )
    const uom = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirManifestQtyList.UOM
    )
    const aciAirEquipmentList = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirEquipmentList.TITLE
    )
    const containerid = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirEquipmentList.CONTAINERID
    )
    const aciAirItemList = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirItemList.TITLE
    )
    const itemNo = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirItemList.ITEM_NO
    )
    const ladingQuantity = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirItemList.LADING_QUANTITY
    )
    const ladingUom = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirItemList.LADING_UOM
    )
    const productDesc = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirItemList.PRODUCT_DESC
    )
    const grossWeightUom = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirItemList.GROSS_WEIGHT_UOM
    )
    const grossWeight = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirItemList.GROSS_WEIGHT
    )
    const aciAirStatusNotifyList = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirStatusNotifyList.TITLE
    )
    const statusType = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirStatusNotifyList.STATUS_TYPE
    )
    const email = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirStatusNotifyList.EMAIL
    )
    const phoneNumber = translate(
      Namespace.ACI_AIR,
      AciAirKeys.AciAirStatusNotifyList.PHONE_NUMBER
    )
    const ccn = translate(
      Namespace.ACI_AIR,
      AciAirKeys.CCN
    )

    return {
      schedule,
      customsProc,
      convRefNo,
      flightNo,
      originalCCN,
      carrierCode,
      portOfLoading,
      receiptCountry,
      receiptCity,
      deliveryCountry,
      deliveryCity,
      customsOff,
      warehouseDischarge,
      splitShipmentInd,
      rampTransferInd,
      suppReqInd,
      specialIns,
      scheduleDateAndTime,
      uniqueConsignmentRefNo,
      receiptTerminalName,
      cargoFacilityLoc,
      customsOfficeDischarge,
      customsOfficeDischargeLoc,
      aciAirRouteList,
      routeCarrierCode,
      locationCode,
      aciAirPartyList,
      partyType,
      partyName1,
      partyName2,
      address1,
      address2,
      city,
      stateCode,
      postalCode,
      countryCode,
      contactPerson,
      telNo,
      aciAirManifestQtyList,
      quantity,
      uom,
      aciAirEquipmentList,
      containerid,
      aciAirItemList,
      itemNo,
      ladingQuantity,
      ladingUom,
      productDesc,
      grossWeightUom,
      grossWeight,
      aciAirStatusNotifyList,
      statusType,
      email,
      phoneNumber,
      ccn
    }
  }

  const itemTableColumns = [
    {
      field: 'itemNo',
      sortKey: 'itemNo',
      title: translatedTextsObject.itemNo
    },
    {
      field: 'productDesc',
      sortKey: 'productDesc',
      title: translatedTextsObject.productDesc
    },
    {
      field: 'ladingQuantity',
      sortKey: 'ladingQuantity',
      title: translatedTextsObject.ladingQuantity
    },
    {
      field: 'ladingUom',
      sortKey: 'ladingUom',
      title: translatedTextsObject.ladingUom,
      render: (rowData) => (
        <Typography component='div' variant='inherit'>
          {getLookupValue('uomType', rowData.ladingUom)}
          <TinyChip label={rowData.ladingUom} variant='outlined' />
        </Typography>
      )
    },
    {
      field: 'grossWeight',
      sortKey: 'grossWeight',
      title: translatedTextsObject.grossWeight
    },
    {
      field: 'grossWeightUom',
      sortKey: 'grossWeightUom',
      title: translatedTextsObject.grossWeightUom,
      render: (rowData) => (
        <Typography component='div' variant='inherit'>
          {getLookupValue('grossWeightUom', rowData.grossWeightUom)}
          <TinyChip label={rowData.grossWeightUom} variant='outlined' />
        </Typography>
      )
    }
  ]

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <StatusBar status={data.hdrStatus} />
      </Grid>
      <Grid item xs={12}>
        <Card variant='outlined'>
          <Box padding={2}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box mb={2}>
                  <Typography variant='h5' style={{ fontWeight: 600 }}>
                    General Information
                  </Typography>
                </Box>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6} md={3}>
                    <CngField label={translatedTextsObject.carrierCode}>
                      {data.carrierCode}
                    </CngField>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <CngField label={translatedTextsObject.ccn}>
                      {data.ccn}
                    </CngField>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <CngField label={translatedTextsObject.customsProc}>
                      {data.customsProc && (
                        <Typography component='div' variant='inherit'>
                          {getLookupValue('customsProc', data.customsProc)}
                          <TinyChip label={data.customsProc} variant='outlined' />
                        </Typography>
                      )}
                    </CngField>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <CngField label={translatedTextsObject.splitShipmentInd}>
                      {data.splitShipmentInd === '1' ? 'Yes' : 'No'}
                    </CngField>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <CngField label={translatedTextsObject.rampTransferInd}>
                      {data.rampTransferInd === '1' ? 'Yes' : 'No'}
                    </CngField>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <CngField label={translatedTextsObject.suppReqInd}>
                      {data.suppReqInd === '1' ? 'Yes' : 'No'}
                    </CngField>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <CngField label={translatedTextsObject.uniqueConsignmentRefNo}>
                      {data.uniqueConsignmentRefNo}
                    </CngField>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <CngField label={translatedTextsObject.specialIns}>
                      {data.specialIns}
                    </CngField>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <CngSection title={translatedTextsObject.aciAirManifestQtyList}>
                  <Grid container spacing={2}>
                    {data.aciAirManifestQtyList.map((manifestQuantity) => (
                      <Grid key={manifestQuantity.id} item xs={12} sm={6} md={3}>
                        <CngField
                          label={[
                            translatedTextsObject.quantity,
                            translatedTextsObject.uom
                          ].join(' & ')}
                        >
                          <Typography component='div'>
                            {manifestQuantity.quantity}&nbsp;-&nbsp;
                            <Typography
                              component='div'
                              variant='inherit'
                              style={{ display: 'inline-block' }}
                            >
                              {getLookupValue('uomType', manifestQuantity.uom)}
                              <TinyChip label={manifestQuantity.uom} variant='outlined' />
                            </Typography>
                          </Typography>
                        </CngField>
                      </Grid>
                    ))}
                  </Grid>
                </CngSection>
              </Grid>
              <Grid item xs={12}>
                <CngSection title={translatedTextsObject.aciAirEquipmentList}>
                  <Grid container spacing={2}>
                    {data.aciAirEquipmentList.map((equipment) => (
                      <Grid key={equipment.id} item xs={12} sm={6} md={3}>
                        <CngField label={translatedTextsObject.containerid}>
                          {equipment.containerid}
                        </CngField>
                      </Grid>
                    ))}
                  </Grid>
                </CngSection>
              </Grid>
              <Grid item xs={12}>
                <CngSection
                  action={
                    <Box display='flex' alignItems='center' style={{ gap: 8 }}>
                      <FontAwesomeIcon
                        color={
                          data.scheduledSubmissionFlag
                            ? theme.palette.success.main
                            : theme.palette.error.main
                        }
                        icon={['fal', data.scheduledSubmissionFlag ? 'circle-check' : 'ban']}
                      />
                      <Typography
                        color='textSecondary'
                        variant='body2'
                        style={{ fontWeight: 600 }}
                      >
                        Schedule Delivery
                      </Typography>
                    </Box>
                  }
                  title={translatedTextsObject.schedule}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={3}>
                      <CngField label={translatedTextsObject.flightNo}>
                        {data.flightNo}
                      </CngField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <CngField label={translatedTextsObject.convRefNo}>
                        {data.convRefNo}
                      </CngField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <CngField label={translatedTextsObject.receiptCountry}>
                        <Typography component='div' variant='inherit'>
                          {getLookupValue('country', data.receiptCountry)}
                          <TinyChip label={data.receiptCountry} variant='outlined' />
                        </Typography>
                      </CngField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <CngField label={translatedTextsObject.receiptCity}>
                        {data.receiptCity}
                      </CngField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <CngField label={translatedTextsObject.receiptTerminalName}>
                        {data.receiptTerminalName}
                      </CngField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <CngField label={translatedTextsObject.deliveryCountry}>
                        <Typography component='div' variant='inherit'>
                          {getLookupValue('country', data.deliveryCountry)}
                          <TinyChip label={data.deliveryCountry} variant='outlined' />
                        </Typography>
                      </CngField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <CngField label={translatedTextsObject.deliveryCity}>
                        {data.deliveryCity}
                      </CngField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <CngField label={translatedTextsObject.cargoFacilityLoc}>
                        {data.cargoFacilityLoc}
                      </CngField>
                    </Grid>
                    {(data.customsProc === '23' || data.customsProc === '24') && (
                      <>
                        <Grid item xs={12} sm={6} md={3}>
                          <CngField label={translatedTextsObject.customsOfficeDischarge}>
                            {data.customsOfficeDischarge && (
                              <Typography component='div' variant='inherit'>
                                {getLookupValue('customsOffice', data.customsOfficeDischarge)}
                                <TinyChip label={data.customsOfficeDischarge} variant='outlined' />
                              </Typography>
                            )}
                          </CngField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                          <CngField label={translatedTextsObject.customsOfficeDischargeLoc}>
                            {data.customsOfficeDischargeLoc && (
                              <Typography component='div' variant='inherit'>
                                {getLookupValue('sublocation', data.customsOfficeDischargeLoc)}
                                <TinyChip label={data.customsOfficeDischargeLoc} variant='outlined' />
                              </Typography>
                            )}
                          </CngField>
                        </Grid>
                      </>
                    )}
                    <Grid item xs={12} sm={6} md={3}>
                      <CngField label={translatedTextsObject.portOfLoading}>
                        <Typography component='div' variant='inherit'>
                          {getLookupValue('airport', data.portOfLoading)}
                          <TinyChip label={data.portOfLoading} variant='outlined' />
                        </Typography>
                      </CngField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <CngField label={translatedTextsObject.customsOff}>
                        {data.customsOff && (
                          <Typography component='div' variant='inherit'>
                            {getLookupValue('customsOffice', data.customsOff)}
                            <TinyChip label={data.customsOff} variant='outlined' />
                          </Typography>
                        )}
                      </CngField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <CngField label={translatedTextsObject.warehouseDischarge}>
                        {data.warehouseDischarge && (
                          <Typography component='div' variant='inherit'>
                            {getLookupValue('sublocation', data.warehouseDischarge)}
                            <TinyChip label={data.warehouseDischarge} variant='outlined' />
                          </Typography>
                        )}
                      </CngField>
                    </Grid>
                    {data.scheduledSubmissionFlag &&
                      data.scheduleDateAndTime && (
                        <Grid item xs={12} sm={6} md={3}>
                          <CngField label={translatedTextsObject.scheduleDateAndTime}>
                            {moment(data.scheduleDateAndTime).format('DD/MM/YYYY HH:mm:ss')}
                          </CngField>
                        </Grid>
                      )}
                  </Grid>
                </CngSection>
              </Grid>
              <Grid item xs={12}>
                <CngSection title={translatedTextsObject.aciAirRouteList}>
                  <Grid container spacing={2}>
                    {data.aciAirRouteList.map((route) => (
                      <Grid key={route.id} item xs={12} sm={6} md={3}>
                        <CngField
                          label={[
                            translatedTextsObject.routeCarrierCode,
                            translatedTextsObject.locationCode
                          ].join(' & ')}
                        >
                          <Typography component='div'>
                            {getLookupValue('carrierCode', route.carrierCode)}&nbsp;-&nbsp;
                            <Typography
                              component='div'
                              variant='inherit'
                              style={{ display: 'inline-block' }}
                            >
                              {getLookupValue('airport', route.locationCode)}
                              <TinyChip label={route.locationCode} variant='outlined' />
                            </Typography>
                          </Typography>
                        </CngField>
                      </Grid>
                    ))}
                  </Grid>
                </CngSection>
              </Grid>
            </Grid>
          </Box>
        </Card>
      </Grid>
      <Grid item xs={12}>
        <CngSection title={translatedTextsObject.aciAirPartyList}>
          {!_.isEmpty(data.aciAirPartyList) ? (
            <Grid container spacing={2}>
              {data.aciAirPartyList.map((party) => (
                <Grid key={party.id} item xs={12}>
                  <Card variant='outlined' style={{ backgroundColor: theme.palette.grey[100] }}>
                    <Box padding={2}>
                      <Grid container spacing={2}>
                        <Grid container spacing={2} item xs={12}>
                          <Grid item xs={12} sm={6} md={3}>
                            <CngField label={translatedTextsObject.partyType}>
                              {getLookupValue('partyType', party.partyType)}
                            </CngField>
                          </Grid>
                          <Grid item xs={12} sm={6} md={3}>
                            <CngField label={translatedTextsObject.partyName1}>
                              {party.partyName1}
                            </CngField>
                          </Grid>
                          <Grid item xs={12} sm={6} md={3}>
                            <CngField label={translatedTextsObject.partyName2}>
                              {party.partyName2}
                            </CngField>
                          </Grid>
                          <Grid item xs={12} sm={6} md={3}>
                            <CngField label={translatedTextsObject.address1}>
                              {party.address1}
                            </CngField>
                          </Grid>
                          <Grid item xs={12} sm={6} md={3}>
                            <CngField label={translatedTextsObject.address2}>
                              {party.address2}
                            </CngField>
                          </Grid>
                          <Grid item xs={12} sm={6} md={3}>
                            <CngField label={translatedTextsObject.city}>
                              {party.city}
                            </CngField>
                          </Grid>
                          <Grid item xs={12} sm={6} md={3}>
                            <CngField label={translatedTextsObject.stateCode}>
                              {party.stateCode}
                            </CngField>
                          </Grid>
                          <Grid item xs={12} sm={6} md={3}>
                            <CngField label={translatedTextsObject.postalCode}>
                              {party.postalCode}
                            </CngField>
                          </Grid>
                          <Grid item xs={12} sm={6} md={3}>
                            <CngField label={translatedTextsObject.countryCode}>
                              <Typography component='div' variant='inherit'>
                                {getLookupValue('country', party.countryCode)}
                                <TinyChip label={party.countryCode} />
                              </Typography>
                            </CngField>
                          </Grid>
                        </Grid>
                        <Grid item xs={12}>
                          <Card variant='outlined'>
                            <Box padding={2}>
                              <Grid alignItems='center' container spacing={1}>
                                <Grid item xs={12} md={3}>
                                  <Typography
                                    color='textSecondary'
                                    variant='body1'
                                    style={{ fontWeight: 600 }}
                                  >
                                    Contact Person
                                  </Typography>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <CngField label={translatedTextsObject.contactPerson}>
                                    {party.contactPerson}
                                  </CngField>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                  <CngField label={translatedTextsObject.telNo}>
                                    {party.telNo}
                                  </CngField>
                                </Grid>
                              </Grid>
                            </Box>
                          </Card>
                        </Grid>
                      </Grid>
                    </Box>
                  </Card>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Typography color='textSecondary'>
              No records to display
            </Typography>
          )}
        </CngSection>
      </Grid>
      <Grid item xs={12}>
        <Card variant='outlined'>
          <LocalTable
            columns={itemTableColumns}
            data={data.aciAirItemList}
            header={
              <Typography
                component='div'
                variant='h5'
                style={{ fontWeight: 600 }}
              >
                {translatedTextsObject.aciAirItemList}
              </Typography>
            }
            onRowClick={(data) => setItemDialog({ open: true, item: data })}
          />
          <ItemDialog
            open={itemDialog.open}
            onClose={() => setItemDialog({ open: false, item: null })}
            title='Commodity'
            item={itemDialog.item}
          />
        </Card>
      </Grid>
      <Grid item xs={12}>
        <CngSection title={translatedTextsObject.aciAirStatusNotifyList}>
          {!_.isEmpty(data.aciAirStatusNotifyList) ? (
            <Grid container spacing={2}>
              {data.aciAirStatusNotifyList.map((statusNotification, index) => (
                <React.Fragment key={statusNotification.id}>
                  <Grid container spacing={2} item xs={12}>
                    <Grid item xs={12} md={4}>
                      <CngField label={translatedTextsObject.email}>
                        {statusNotification.email}
                      </CngField>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <CngField label={translatedTextsObject.phoneNumber}>
                        {statusNotification.phoneNumber}
                      </CngField>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <CngField label={translatedTextsObject.statusType}>
                        {getLookupValue('statusType', statusNotification.statusType)}
                      </CngField>
                    </Grid>
                  </Grid>
                  {data.aciAirStatusNotifyList.length !== index + 1 && (
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                  )}
                </React.Fragment>
              ))}
            </Grid>
          ) : (
            <Typography color='textSecondary'>
              No records to display
            </Typography>
          )}
        </CngSection>
      </Grid>
      <Grid item xs={12}>
        <ViewLogsHistory
          ccnValue={data.ccn}
          headerId={reportId}
          showNotification={showNotification}
        />
      </Grid>
    </Grid>
  )
}

function ItemDialog(props) {
  const { onClose, open, item, title } = props

  return (
    <CngDialog
      customDialogContent={
        <Box p={2}>
          {item ? (
            <ItemViewContent item={item} />
          ) : (
            <Box display='flex' alignItems='center' justifyContent='center'>
              <CircularProgress />
            </Box>
          )}
        </Box>
      }
      dialogAction={<CngButton onClick={onClose}>OK</CngButton>}
      dialogTitle={title}
      maxWidth='md'
      fullWidth
      onClose={onClose}
      open={open}
      shouldShowCloseButton
    />
  )
}

export default ReportViewContent
